import { render, staticRenderFns } from "./SelectWares.vue?vue&type=template&id=510f23ab&scoped=true&"
import script from "./SelectWares.vue?vue&type=script&lang=js&"
export * from "./SelectWares.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "510f23ab",
  null
  
)

export default component.exports